import { defaultSvgIcons, type IconKey } from '@mdxeditor/editor'
import type { JSX } from 'react'

/**
 * Os ícones da barra: os do MDXEditor, menos sublinhado e riscado, que o cliente pediu como letras
 * ("S" sublinhado e "abc" riscado, como no Word em português), não como o "U" dos ícones padrão.
 */
export function iconComponentFor(name: IconKey): JSX.Element {
  if (name === 'format_underlined') {
    return (
      <span aria-hidden className="wx-ed-glyph wx-ed-glyph--underline">
        S
      </span>
    )
  }
  if (name === 'strikeThrough') {
    return (
      <span aria-hidden className="wx-ed-glyph wx-ed-glyph--strike">
        abc
      </span>
    )
  }
  return defaultSvgIcons[name]
}
